module.exports = __webpack_public_path__ + "img/dataReport_5.7271137b.png";